<main class="settings">
  <!-- #tpl-main-section / renderMainSection -->
  <span (click)="goBack()" class="settings__back-arrow">
    <svg width="17" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.194 5.872H3.907l3.454-4.15A.953.953 0 1 0 5.896.505l-4.759 5.71c-.032.046-.06.094-.085.143 0 .048-.048.076-.067.124a.952.952 0 0 0-.067.343c.001.117.024.233.067.342 0 .048.048.076.067.124.025.05.053.097.085.143l4.759 5.71a.952.952 0 0 0 1.342.124.951.951 0 0 0 .123-1.342l-3.454-4.15h11.287a.952.952 0 0 0 0-1.903Z"
        fill="#fff" />
    </svg>
  </span>
  <header class="header">
    <h1 class="header__title">My Settings</h1>
    <!-- <h2>Logged in with: {{displayedName}}</h2> -->
  </header>
  <form class="form flex-col gap-2" [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
    <div class="flex-col gap-2">
      <div class="flex-col gap-1">
        <img class="form__img" [src]="logo? logo : userInfo.profileImage" alt="User's Profile Picture" />
        <input class="form__input" type="file" name="profile-pic-input" accept="image/*"
          (change)="onFileChanged($event)" title="Upload Profile Picture" #fileInput />
      </div>

      <fieldset class="form__section flex-col gap-1 w-100">
        <h3 class="form__title">Password Change</h3>
        <div class="form__label-container">
          <label class="form__label" for="new-password">New password</label>
          <input class="form__input" formControlName="password" formControlName="password" (input)="checkPasswords()"
            type="password" name="new-password" title="Input New Password" />

          <div *ngIf="f.password.errors">
            <div *ngIf="f.password.errors">Password needs to be at least 8 characters long</div>
          </div>
        </div>
        <div class="form__label-container">
          <label class="form__label" for="repeat-password">Repeat password</label>
          <input class="form__input" formControlName="repeatedPassword" formControlName="repeatedPassword"
            (input)="checkPasswords()" type="password" name="repeat-password" title="Repeat New Password" />
          <div *ngIf="!passwordMatches">Passwords do not match</div>
        </div>
      </fieldset>
    </div>

    <fieldset class="form__section flex-col gap-1">
      <h3 class="form__title">Personal Info</h3>
      <div class="form__label-container">
        <label class="form__label" class="form__label" for="display-name">Display Name</label>
        <input class="form__input" type="text" name="display-name" formControlName="displayName"
          [(ngModel)]="userInfo.displayName" title="Display Name" />
        <span class="form__caption form__caption--light-blue">Can be changed unlimited times. Hosts view the name you
          had at the time you send your request.</span>
      </div>
      <div class="form__label-container">
        <label class="form__label" for="first-name">First Name</label>
        <input class="form__input" formControlName="firstName" type="text" name="first-name"
          [(ngModel)]="userInfo.firstName" title="First Name" />
      </div>
      <div class="form__label-container">
        <label class="form__label" for="last-name">Last Name</label>
        <input class="form__input" formControlName="lastName" type="text" name="last-name"
          [(ngModel)]="userInfo.lastName" title="Last Name" />
      </div>

      <div class="form__divider-horizontal"></div>

      <div class="form__label-container">
        <label class="form__label" for="country">Country</label>
        <select class="form__select" [(ngModel)]="userInfo.country" [ngModelOptions]="{standalone: true}"
          title="Select Country">
          <option *ngFor="let country of countries" value="{{country}}" title="{{country}}">{{country}} </option>
        </select>
      </div>
      <div class="form__label-container">
        <label class="form__label" for="phone">Phone</label>
        <!-- <input class="form__input" formControlName="phonePrefix" formControlName="phonePrefix" type="text"
						name="phonePrefix" id="phonePrefix" [(ngModel)]="userInfo.phonePrefix"> -->
        <input class="form__input" formControlName="phone" formControlName="phone" type="text" name="phone"
          [(ngModel)]="userInfo.phone" title="Input Phone Number" />
        <!-- <div *ngIf="f.phonePrefix.errors">
					<div *ngIf="f.phonePrefix.errors">Please enter a valid country code</div>
				</div> -->
        <div *ngIf="f.phone.errors">
          <div *ngIf="f.phone.errors">Please enter a valid phone number</div>
        </div>
      </div>
      <div class="form__label-container">
        <label class="form__label" for="email">Email</label>
        <input class="form__input" formControlName="email" formControlName="email" type="text" name="email" id="email"
          [(ngModel)]="userInfo.email" />

        <div *ngIf="f.email.errors">
          <div *ngIf="f.email.errors.required">Please enter a valid email</div>
        </div>

        <div class="form__caption form__caption--light-blue" *ngIf="!userInfo.emailVerified">
          Please confirm your email. If you haven't received the confirmation email,
          <a class="form__link" (click)="sendUserEmailConfirm()">click here to resend it.</a>
        </div>
      </div>
    </fieldset>
  </form>

  <button class="button button--lg button--pink button--shadow-blue" id="submit" (click)="onSubmit()" type="submit">Save
    all changes</button>

  <button (click)="logoutUser()" class="button button-logout">Logout</button>

</main>
<div id="modal-background"></div>
<div id="modal-content">
  <div class="loader"></div>
</div>